<!--this model for edite the item in the stock allocation form and edit Stock allocation-->
<template>
  <div v-if="show" class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4>Edit Item</h4>
        <span class="close" @click="$emit('close')">&times;</span>
      </div>
      <div class="dropdown-container-modal">
        <div class="dropdown-item">
          <label for="edit-item-select">Item Name</label>
          <select id="edit-item-select" v-model="localItemName" disabled>
            <option v-for="item in items" :key="item.id" :value="item.id">{{ item.variant_name ? item.variant_name : item.item_name ? item.item_name : '' }}</option>
          </select>
        </div>
      </div>
      <div class="dropdown-container-modal">
        <div class="dropdown-item">
          <label for="edit-quantity-input">Item Quantity</label>
          <input type="number" id="edit-quantity-input" v-model="localItemQuantity" placeholder="Enter quantity" min="0" />
          <div class="mt-1" v-if="availableStock !== null && availableStock !== undefined">
            <small class="text-muted font-weight-bold">Available Stock: {{ availableStock }}</small>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-success mt-4" @click="updateItem">Update</button>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";

export default {
  props: {
    show: Boolean,
    itemName: String,
    itemQuantity: Number,
    items: Array,
    availableStock: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      localItemName: this.itemName,
      localItemQuantity: this.itemQuantity
    };
  },
  watch: {
    itemName(newVal) {
      this.localItemName = newVal;
    },
    itemQuantity(newVal) {
      this.localItemQuantity = newVal;
    }
  },
  methods: {
    updateItem() {
      if (!Number.isInteger(Number(this.localItemQuantity))) {
        const toast = useToast();
        toast.error("Quantity must be a whole number.");
        return;
      }
      this.$emit('update', { itemName: this.localItemName, itemQuantity: this.localItemQuantity });
    }
  }
};


</script>

<style lang="scss" scoped>
@import '@/assets/scss/pages/modal/modal.scss';
</style>

<!--<style scoped>-->
<!--/* Wrapper for all dropdowns */-->
<!--.dropdowns-wrapper {-->
<!--  width: 100%;-->
<!--  display: grid;-->
<!--  grid-template-columns: repeat(3, 1fr); /* 3x3 grid layout */-->
<!--  gap: 15px; /* Adjust spacing between items */-->
<!--  justify-content: center; /* Center dropdowns horizontally */-->
<!--  margin-bottom: 20px; /* Space between dropdowns and table */-->
<!--}-->

<!--/* Container for dropdowns */-->
<!--.dropdown-container {-->
<!--  display: flex;-->
<!--  flex: 1;-->
<!--  min-width: 180px; /* Minimum width for each dropdown item */-->
<!--  max-width: 250px; /* Maximum width for each dropdown item */-->
<!--}-->

<!--/* Each dropdown item with label */-->
<!--.dropdown-item {-->
<!--  flex: 1;-->
<!--}-->

<!--/* Styling for labels */-->
<!--label {-->
<!--  display: block;-->
<!--  margin-bottom: 5px;-->
<!--  font-weight: bold;-->
<!--  font-size: 14px; /* Adjust font size for better readability */-->
<!--}-->

<!--/* Styling for select elements */-->
<!--select {-->
<!--  width: 100%; /* Ensure select takes full width of its container */-->
<!--  padding: 10px;-->
<!--  border-radius: 5px;-->
<!--  border: 1px solid #ccc;-->
<!--  font-size: 14px; /* Adjust font size for better readability */-->
<!--  transition: border-color 0.3s, box-shadow 0.3s;-->
<!--}-->

<!--/* Focus styling for select elements */-->
<!--select:focus {-->
<!--  border-color: #007bff;-->
<!--  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);-->
<!--  outline: none;-->
<!--}-->

<!--/* Ensure the input for Item Quantity looks similar to the dropdown */-->
<!--input[type="number"] {-->
<!--  width: 100%; /* Ensure input takes full width of its container */-->
<!--  padding: 10px; /* Same padding as the dropdown */-->
<!--  border-radius: 5px; /* Rounded corners like the dropdown */-->
<!--  border: 1px solid #ccc; /* Border style similar to the dropdown */-->
<!--  font-size: 14px; /* Adjust font size for consistency */-->
<!--  transition: border-color 0.3s, box-shadow 0.3s;-->
<!--}-->

<!--/* Focus styling for input elements */-->
<!--input[type="number"]:focus {-->
<!--  border-color: #007bff;-->
<!--  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);-->
<!--  outline: none;-->
<!--}-->

<!--/* Error message styling */-->
<!--.error-message {-->
<!--  color: red;-->
<!--  font-weight: bold;-->
<!--  margin-bottom: 20px;-->
<!--}-->

<!--.dropdown-container-modal {-->
<!--  grid-column: 1 / 3;-->
<!--}-->
<!--.modal-content {-->
<!--  background-color: #fff;-->
<!--  padding: 30px;-->
<!--  border: 1px solid #888;-->
<!--  width: 500px;-->
<!--  border-radius: 10px;-->
<!--  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);-->
<!--  display: grid;-->
<!--  grid-template-columns: 1fr 1fr;-->
<!--  gap: 20px;-->
<!--  align-items: center;-->
<!--  white-space: nowrap; /* Prevent text from wrapping */-->
<!--  overflow: hidden; /* Hide overflow text */-->
<!--  text-overflow: ellipsis; /* Add ellipsis for overflow text */-->
<!--}-->

<!--.modal-header {-->
<!--  display: flex;-->
<!--  justify-content: space-between;-->
<!--  align-items: center;-->
<!--  width: 100%;-->
<!--  grid-column: 1 / 3;-->
<!--}-->

<!--.close {-->
<!--  color: #aaa;-->
<!--  font-size: 28px;-->
<!--  font-weight: bold;-->
<!--  cursor: pointer;-->
<!--}-->

<!--.close:hover,-->
<!--.close:focus {-->
<!--  color: black;-->
<!--  text-decoration: none;-->
<!--}-->

<!--.dropdown-container-modal {-->
<!--  grid-column: 1 / 3;-->
<!--}-->

<!--button.btn-success {-->
<!--  grid-column: 2 / 3;-->
<!--  justify-self: end;-->
<!--}-->

<!--.button-container {-->
<!--  display: flex;-->
<!--  justify-content: center;-->
<!--  gap: 10px;-->
<!--  margin-top: 20px;-->
<!--}-->

<!--.modal-content-confirmation {-->
<!--  background-color: #fff;-->
<!--  padding: 30px;-->
<!--  border: 1px solid #888;-->
<!--  width: 500px;-->
<!--  border-radius: 10px;-->
<!--  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);-->
<!--  display: grid;-->
<!--  grid-template-columns: 1fr 1fr;-->
<!--  gap: 20px;-->
<!--  align-items: center;-->
<!--  white-space: nowrap; /* Prevent text from wrapping */-->
<!--  overflow: hidden; /* Hide overflow text */-->
<!--  text-overflow: ellipsis; /* Add ellipsis for overflow text */-->
<!--  position: relative; /* Ensure the close button is positioned relative to the modal */-->
<!--}-->

<!--.modal-content-confirmation .close {-->
<!--  position: absolute;-->
<!--  top: 10px;-->
<!--  right: 10px;-->
<!--  color: #aaa;-->
<!--  font-size: 28px;-->
<!--  font-weight: bold;-->
<!--  cursor: pointer;-->
<!--}-->

<!--.modal-content-confirmation .close:hover,-->
<!--.modal-content-confirmation .close:focus {-->
<!--  color: black;-->
<!--  text-decoration: none;-->
<!--}-->

<!--.modal-content-confirmation .button-container {-->
<!--  display: flex;-->
<!--  justify-content: flex-end; /* Align buttons to the right */-->
<!--  gap: 10px;-->
<!--  grid-column: 1 / 3; /* Ensure the buttons span both columns */-->
<!--}-->
<!--</style>-->